import { Box, Group, useMantineTheme } from '@mantine/core';

type ConditionActionBoxProps = {
  children: React.ReactNode;
};

export const ConditionActionBox = ({ children }: ConditionActionBoxProps) => {
  const theme = useMantineTheme();

  return (
    <Box
      bg="gray.0"
      mt="space4"
      p={6}
      bdrs="md"
      style={{ border: `1px solid ${theme.colors.gray[2]}` }}
    >
      <Group gap="space2">{children}</Group>
    </Box>
  );
};
